import { render, staticRenderFns } from "./OrderCardRates.vue?vue&type=template&id=65a7b7db&scoped=true&"
import script from "./OrderCardRates.vue?vue&type=script&lang=ts&"
export * from "./OrderCardRates.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a7b7db",
  null
  
)

export default component.exports